import { AppBar, Button, Grid, List, ListItem, ListItemText, ListSubheader, Paper, TextField, Toolbar, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search'

import React, { useEffect, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Box } from '@mui/system';

import ErrorPaper from '../components/ErrorPaper';
import { useAuth } from '../components/AuthContext';

const PensieveBaseUri = 'http://api.epensieve.com';

const Styles = ({
    paper: {
        maxWidth: { xl: 1240, lg: 940, md: 640, sm: 480, xs: 320 },
        width: { xl: 1200, lg: 900, md: 600, sm: 480, xs: 320 },
        margin: '20px auto',
        overflow: 'hidden',
    },
    searchBar: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },
    searchInput: {
        fontSize: 'primary',
    },
    block: {
        display: 'block',
    },
    addTopic: {
        marginRight: 1,
    },
    contentWrapper: {
        margin: '40px 16px',
    },
})

type Topic = {
    name: string,
    summary: string
}

function TopicsExplorer() {
    const {userId} = useAuth()!;
    const [loading, setLoading] = useState(true);
    const [topics, setTopics] = useState<Topic[]>([]);
    const [filter, setFilter] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let url = `${PensieveBaseUri}/topics?detailed=true${(userId) ? '&userId='+userId : ''}`;
        fetch(url, {method: 'GET'})
        .then( (response) => {
            if (!response.ok) {
                throw new Error('Issue retrieving the detailed list of Topics');
            }

            return response.json();
        })
        .then((result) => {
            setTopics(result.topics);
            setLoading(false);
        })
        .catch((err) => {
            setError(err.message);
        })
    }, [userId]);

    if (loading) {
        return (<Paper sx={Styles.paper} > <Typography> Loading Topics ... </Typography> </Paper>);
    }

    return (
        <Box>
            { (error) && <ErrorPaper error={error} /> }
            <Paper sx={Styles.paper} >
                <AppBar sx={Styles.searchBar} position='static' color='default' elevation={0} >
                    <Toolbar>
                        <Grid container spacing={2} alignItems='center' >
                            <Grid item>
                                <SearchIcon color='inherit' sx={Styles.block} />
                            </Grid>
                            <Grid item xs >
                                <TextField
                                    fullWidth
                                    placeholder='Filter'
                                    variant='standard'
                                    onChange={(evt) => { setFilter(evt.currentTarget.value); }}
                                    sx={Styles.searchInput}
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                >
                                </TextField>
                            </Grid>
                            <Grid item>
                                <Button variant='contained' color='primary' sx={Styles.addTopic}
                                        component={RouterLink} to={(filter) ? `/topic/${encodeURI(filter!)}` : '/topic'} >
                                    Add Topic
                                </Button>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
                <Box sx={Styles.contentWrapper} >
                    <List 
                        component='nav'
                        aria-labelledby='nested-list-subheader'
                        subheader={
                            <ListSubheader component='div' id='nested-list-subheader'>
                                {(filter && `Filtering list by topics starting with "${filter}"`)}
                            </ListSubheader>
                        }
                    >
                        { topics
                            .filter((topic) => topic.name.toUpperCase().startsWith(filter?.toUpperCase() || ''))
                            .map((topic) => (
                                <ListItem button key={topic.name} component={RouterLink} to={`/topic/${encodeURI(topic.name)}`} >
                                    <ListItemText primary={topic.name} secondary={topic.summary} />
                                </ListItem>
                            ))
                        }
                    </List>
                </Box>
            </Paper>
        </Box>
    );
}

export default TopicsExplorer